// extracted by mini-css-extract-plugin
export default {"loading_modal_body":"loading-modal_loading_modal_body__pkVUM"};